import {createQueryKeys} from "../../shared/query/query-keys";

export const leadKeys = {
  ...createQueryKeys("leads"),
  similarity: (search: object) => ["leads", "similarity", search] as const,
};

export const leadMutationKeys = {
  createLead: ["leads", "mutation", "create-lead"] as const,
  updateLead: ["leads", "mutation", "update-lead"] as const,
  deleteLead: ["leads", "mutation", "delete-lead"] as const,
  restoreLead: ["leads", "mutation", "restore-lead"] as const,
  convertLeadToClient: ["leads", "mutation", "convert-lead-to-client"] as const,
  addLeadContact: ["leads", "mutation", "add-lead-contact"] as const,
  editLeadContact: ["leads", "mutation", "edit-lead-contact"] as const,
  removeLeadContact: ["leads", "mutation", "remove-lead-contact"] as const,
  addLeadNote: ["leads", "mutation", "add-lead-note"] as const,
  editLeadNote: ["leads", "mutation", "edit-lead-note"] as const,
  removeLeadNote: ["leads", "mutation", "remove-lead-note"] as const,
} as const;
